module.exports = __webpack_public_path__ + "img/partners-7.49d6a37c.png";